import { useFormContext, useWatch } from 'react-hook-form';
import { SelectField, TextInputField } from '@brighte/form-components';
import { EmploymentType, IncomeVerificationType } from '@brighte/validation';
import { LABELS, PLACEHOLDER } from '@utils';
import ABNInput from './ABNInput';
import RetiredOrPensioner from './RetiredOrPensioner';
import { getIncomeOptions } from './helpers';

type EmploymentFieldsProps = {
  financialProductId: string;
};

function EmploymentFields({ financialProductId }: EmploymentFieldsProps) {
  const { control, setValue, register } = useFormContext<IncomeVerificationType>();
  const applicantIncomeType = useWatch({ control, name: 'applicant.employment.type' });

  const resetEmploymentFields = () => {
    if (applicantIncomeType) {
      setValue(
        `applicant.employment.${applicantIncomeType === 'self-employed' ? 'selfEmployed' : applicantIncomeType}`,
        undefined,
      );
    }
  };

  const employmentFields = {
    [EmploymentType.EMPLOYED]: (
      <TextInputField
        name="applicant.employment.employed.employerBusinessName"
        control={control}
        label={LABELS.EMPLOYER_NAME}
      />
    ),
    [EmploymentType.SELF_EMPLOYED]: <ABNInput control={control} setValue={setValue} register={register} />,
    [EmploymentType.PENSIONER]: <RetiredOrPensioner control={control} />,
    [EmploymentType.OTHER]: null,
  };

  return (
    <>
      <SelectField
        name="applicant.employment.type"
        control={control}
        label={LABELS.INCOME_TYPE}
        options={getIncomeOptions(financialProductId)}
        placeholder={PLACEHOLDER}
        onChange={resetEmploymentFields}
      />
      <>{employmentFields[applicantIncomeType] ?? null}</>
    </>
  );
}

export default EmploymentFields;
